export enum Role {
    DeviceApi,
    ApplicationSetup,
    UserManagement,
    Reporting
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/enums/role.enum.ts